<template>
  <div class="medical-detail-cntainer">
    <TopBg title="智慧运营管理平台"
      sub-title="以异常自动发现为入口，通过知识图谱下钻根因、AI Agent生成可执行建议形成“发现—归因—行动—回测”的医院运营管理闭环，帮助管理者提前一个管理周期预警、精准决策、量化效果。"
      :bg="topBg" />
    <div class="main-content page">
      <!-- 产品简介 -->
      <div class="section">
        <div class="title">产品简介</div>
        <div class="disc">
          智慧运营管理平台是以异常发现为入口、知识图谱为分析骨架、AI Agent
          为辅助解释能力的医院运营管理闭环系统。平台覆盖医疗效率、医疗质量、业务结构、成本管控四大维度，帮助管理者在双周/月度节奏上完成"发现异常→理解根因→协同行动→效果回测"的完整管理闭环。
        </div>
      </div>
      <!-- 痛点分析 -->
      <div class="section">
        <div class="title">痛点分析</div>
        <div class="rows-4">
          <PainsAnalysisItem title="发现滞后" desc="传统 BI 依赖人工翻报表，异常往往在会议复盘时才暴露，错过干预窗口。">
            <template #icon>
              <img src="./assets/pain01.svg" alt="" />
            </template>
          </PainsAnalysisItem>
          <PainsAnalysisItem title="归因困难" desc="指标异常后缺乏结构化的下钻路径，管理者难以快速定位是哪个病区、哪个流程环节、哪个共用资源导致问题。">
            <template #icon>
              <img src="./assets/pain02.svg" alt="" />
            </template>
          </PainsAnalysisItem>
          <PainsAnalysisItem title="建议空泛" desc='分析结果停留在"某指标偏高"层面，缺少可执行的行动建议和责任候选。'>
            <template #icon>
              <img src="./assets/pain03.svg" alt="" />
            </template>
          </PainsAnalysisItem>
          <PainsAnalysisItem title="闭环断裂" desc='上期提出的改进建议没有自动跟踪机制，下期无法验证是否生效。'>
            <template #icon>
              <img src="./assets/pain04.svg" alt="" />
            </template>
          </PainsAnalysisItem>
        </div>
      </div>

      <!-- 解决方案 -->
      <div class="section">
        <div class="title">解决方案</div>
        <div class="rows-2">
          <solution-item desc='平台通过确定性算法自动计算指标异常并生成事件，利用知识图谱沿"科室→病区→设备诊室"的真实结构逐层下钻，识别跨科室共用资源瓶颈作为候选根因。'>
            <template #icon>
              <img src="./assets/solution01.svg" alt="" />
            </template>
          </solution-item>
          <solution-item desc="AI Agent在受控范围内生成管理语言解释和可执行建议，每条建议绑定责任候选、追踪指标和回测周期，下一期自动验证改善效果。">
            <template #icon>
              <img src="./assets/solution02.svg" alt="" />
            </template>
          </solution-item>
        </div>
      </div>
      <!-- 产品价值 -->
      <div class="section">
        <div class="title">产品价值</div>
        <div class="rows-4">
          <value-item-vue title="早发现" desc="支持线上复诊、处方流转与药品配送，减少患者奔波，助力优质医疗资源下沉。">
            <template #icon>
              <img src="./assets/value01.svg" alt="" />
            </template>
          </value-item-vue>
          <value-item-vue title="看得懂" desc="图谱可视化展示从异常到根因的完整证据链，管理者一眼定位瓶颈">
            <template #icon>
              <img src="./assets/value02.svg" alt="" />
            </template>
          </value-item-vue>
          <value-item-vue title="能行动" desc="每个候选根因配套具体建议方向和责任协同范围，直接进入双周会议题">
            <template #icon>
              <img src="./assets/value03.svg" alt="" />
            </template>
          </value-item-vue>
          <value-item-vue title="可验证" desc="行动闭环自动回测，管理决策有据可循、效果可量化">
            <template #icon>
              <img src="./assets/value04.svg" alt="" />
            </template>
          </value-item-vue>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBg from "../../common/TopBg.vue";
import PainsAnalysisItem from "../../common/pains-analysis-item.vue";
import valueItemVue from "../../common/value-item.vue";
import SolutionItem from "../../common/solution-item.vue";

export default {
  name: "Operate",
  components: {
    TopBg,
    PainsAnalysisItem,
    valueItemVue,
    SolutionItem
  },
  data() {
    return {
      topBg: require("./assets/bg.png"),
    };
  },
};
</script>
<style scoped>
.solution {
  border-radius: 8px;
  border: 1px solid #d9dbdf;
  background: #fff;
  padding: 32px;
}

@media screen and (max-width: 768px) {
  .solution {
    padding: 16px;
    margin-bottom: 16px;
  }
}

.solution img {
  width: 100%;
}


.solution h1 {
  font-size: 32px;
}

@media screen and (max-width: 768px) {
  .solution h1 {
    font-size: 16px;
    margin-bottom: 16px;
    font-weight: 500;
  }
}

@media screen and (max-width: 1000px) {
    .medical-detail-cntainer>.main-content {
        margin-top: 32px !important;
    }
}

</style>
